export const OPTION_PICKER_ICONS: string[] = [
  // Sentimento / reação
  'thumbs-up', 'thumbs-down', 'star', 'heart',
  // Positivo / Negativo
  'check', 'x', 'zap', 'award',
  // Alerta / Status
  'alert-circle', 'alert-triangle', 'info', 'x-circle',
  // Confirmação
  'check-circle', 'minus-circle', 'plus-circle', 'x-square',
  // Tempo / Lugar
  'calendar', 'clock', 'map-pin', 'sun',
  // Pessoa / Equipe
  'user', 'users', 'home', 'briefcase',
  // Comunicação
  'mail', 'phone', 'message-circle', 'bell',
  // Progresso
  'trending-up', 'trending-down', 'target', 'percent',
  // Marcação
  'flag', 'bookmark', 'tag', 'gift',
  // Outros
  'lock', 'moon', 'shield', 'layers',
];
